export type RaceCategory = string;

export interface ParticipantsPoint {
  quarter: string;
  participantsStarted: number;
  qoq?: Record<string, unknown>;
  yoy?: Record<string, unknown>;
}

export interface RacePoint {
  quarter: string;
  byRace: Record<RaceCategory, number>;
  qoq?: Record<string, unknown>;
  yoy?: Record<string, unknown>;
}

export interface EventsPoint {
  quarter: string;
  communityEngagementTotal: number;
  communityEngagementLarge: number;
  communityEngagementSmall: number;
  educationTotal: number;
  educationLarge: number;
  educationSmall: number;
  qoq?: Record<string, unknown>;
  yoy?: Record<string, unknown>;
}

export interface EducationOutcomePoint {
  quarter: string;
  certifications: number;
  aiFluency: number;
  digitalLiteracy: number;
  digitalExposure: number;
  qoq?: Record<string, unknown>;
  yoy?: Record<string, unknown>;
}

export interface EngagementsPoint {
  quarter: string;
  labResources: number;
  startups: number;
  productsDeveloped: number;
  productsCommercialized: number;
  productsScaled: number;
  qoq?: Record<string, unknown>;
  yoy?: Record<string, unknown>;
}

export interface BlackTechStreetData {
  participants: ParticipantsPoint[];
  participantsAllTimeTotal: number;
  race: RacePoint[];
  raceAllTimeByRace: Record<RaceCategory, number>;
  events: EventsPoint[];
  eventsAllTime: {
    communityEngagementTotal: number;
    communityEngagementLarge: number;
    educationTotal: number;
    educationLarge: number;
    educationSmall: number;
  };
  educationOutcomes: EducationOutcomePoint[];
  engagements: EngagementsPoint[];
}

export function latest<T>(arr: T[]): T {
  return arr[arr.length - 1];
}

export function previous<T>(arr: T[]): T | null {
  return arr.length >= 2 ? arr[arr.length - 2] : null;
}

export function pctChange(current: number, prevVal: number | null): number | null {
  if (prevVal === null || prevVal === 0) return null;
  return ((current - prevVal) / prevVal) * 100;
}
